import { useState } from 'react';
import useScrollReveal from '../hooks/useScrollReveal';
import { SERVICES_DATA, PLANS_DATA, LOCATIONS } from '../data';
import './Contact.css';

export default function Contact() {
  const ref = useScrollReveal();
  const [form, setForm] = useState({ name: '', email: '', phone: '', interest: '', plan: '', message: '' });
  const [errs, setErrs] = useState({});
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(false);

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = 'Name is required';
    if (!form.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) e.email = 'Enter a valid email';
    if (!form.message.trim()) e.message = 'Message is required';
    setErrs(e);
    return !Object.keys(e).length;
  };

  const submit = async (ev) => {
    ev.preventDefault();
    if (!validate()) return;
    setLoading(true);
    await new Promise((r) => setTimeout(r, 1500));
    setLoading(false);
    setSent(true);
    setToast(true);
    setTimeout(() => setToast(false), 4000);
    setForm({ name: '', email: '', phone: '', interest: '', plan: '', message: '' });
  };

  const f = (k) => ({
    value: form[k],
    onChange: (e) => {
      setForm((p) => ({ ...p, [k]: e.target.value }));
      if (errs[k]) setErrs((p) => ({ ...p, [k]: '' }));
    },
  });

  return (
    <div ref={ref}>
      {/* HERO */}
      <div className="page-hero">
        <div className="contact-hero-bg" />
        <div className="page-hero-overlay" />
        <div className="page-hero-content">
          <div className="sec-eyebrow fade-up">Get In Touch</div>
          <h1 className="page-title-xl fade-up delay-1">START YOUR<span className="acc">JOURNEY</span></h1>
        </div>
      </div>

      {/* CONTACT GRID */}
      <section className="section">
        <div className="section-inner">
          <div className="contact-grid">
            {/* INFO */}
            <div className="contact-info fade-left">
              <div className="sec-eyebrow">Find Us</div>
              <h2 className="sec-title" style={{ fontSize: 'clamp(2rem,3.5vw,3.5rem)' }}>
                WE'D LOVE TO <span className="acc">HEAR FROM YOU</span>
              </h2>
              <div className="divider" />

              {[
                { icon: '📍', title: 'Main Location', text: 'new road, Jagamara, Bhubaneswar, Odisha 751020' },
                { icon: '📞', title: 'Phone', text: '+91 (9938326846) ' },
                 { icon: '✉️', title: 'Email', text: 'fitnesskingbbsr@gmail.com' },
                { icon: '🕒', title: 'Opening Hours', text: 'Mon–Fri: 5:00am – 11:00pm\nSat: 6:00am – 10:00pm\nSun: 7:00am – 8:00pm' },
              ].map((c) => (
                <div className="ci-item" key={c.title}>
                  <div className="ci-icon">{c.icon}</div>
                  <div>
                    <div className="ci-title">{c.title}</div>
                    <div className="ci-text" style={{ whiteSpace: 'pre-line' }}>{c.text}</div>
                  </div>
                </div>
              ))}

              {/* Map placeholder */}
              <div className="map-placeholder">
                <div className="map-grid-bg" />
                <div className="map-center">
                  <div className="map-dot" />
                  <span>Chelsea, New York</span>
                </div>
              </div>
            </div>

            {/* FORM */}
            <div className="fade-right">
              <div className="form-wrap">
                <h3 className="form-heading">SEND US A MESSAGE</h3>

                {sent && (
                  <div className="submit-success">
                    ✓ Message received! We'll respond within 24 hours.
                  </div>
                )}

                <form onSubmit={submit} noValidate>
                  <div className="form-row">
                    <div className="field-group">
                      <label className="field-label">Full Name *</label>
                      <input className={`field-input${errs.name ? ' error' : ''}`} placeholder="John Smith" {...f('name')} />
                      {errs.name && <div className="field-error">{errs.name}</div>}
                    </div>
                    <div className="field-group">
                      <label className="field-label">Email Address *</label>
                      <input className={`field-input${errs.email ? ' error' : ''}`} type="email" placeholder="john@email.com" {...f('email')} />
                      {errs.email && <div className="field-error">{errs.email}</div>}
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="field-group">
                      <label className="field-label">Phone Number</label>
                      <input className="field-input" type="tel" placeholder="+1 555 000 0000" {...f('phone')} />
                    </div>
                    <div className="field-group">
                      <label className="field-label">I'm Interested In</label>
                      <select className="field-input" {...f('interest')}>
                        <option value="">Select a service...</option>
                        {SERVICES_DATA.map((s) => <option key={s.title}>{s.title}</option>)}
                        <option>Membership Enquiry</option>
                        <option>General Question</option>
                      </select>
                    </div>
                  </div>

                  <div className="field-group">
                    <label className="field-label">Preferred Membership Plan</label>
                    <select className="field-input" {...f('plan')}>
                      <option value="">Select a plan...</option>
                      {PLANS_DATA.map((p) => (
                        <option key={p.name}>{p.name} — ${p.price}/mo</option>
                      ))}
                      <option>Not sure yet</option>
                    </select>
                  </div>

                  <div className="field-group">
                    <label className="field-label">Message *</label>
                    <textarea
                      className={`field-input${errs.message ? ' error' : ''}`}
                      rows={5}
                      placeholder="Tell us about your fitness goals, current level, and any questions you have..."
                      style={{ resize: 'vertical' }}
                      {...f('message')}
                    />
                    {errs.message && <div className="field-error">{errs.message}</div>}
                  </div>

                  <button type="submit" className="submit-btn" disabled={loading}>
                    {loading ? 'Sending...' : 'Send Message →'}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* LOCATIONS */}
      <section className="section" style={{ background: 'var(--black2)', paddingTop: '6rem', paddingBottom: '6rem' }}>
        <div className="section-inner">
          <div className="text-center fade-up" style={{ marginBottom: '3rem' }}>
            <div className="sec-eyebrow" style={{ justifyContent: 'center' }}>Find Us</div>
            <h2 className="sec-title">OUR <span className="acc">LOCATIONS</span></h2>
            <div className="divider center" />
          </div>
          <div className="locations-grid">
            {LOCATIONS.map((l, i) => (
              <div
                className={`location-card fade-up delay-${i + 1}`}
                key={l.name}
                onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'var(--gold3)'; e.currentTarget.style.transform = 'translateY(-4px)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.borderColor = ''; e.currentTarget.style.transform = ''; }}
              >
                <img src={l.img} alt={l.name} className="location-img" />
                <div className="location-body">
                  <div className="location-size">{l.size}</div>
                  <div className="location-name">{l.name}</div>
                  <div className="location-addr">{l.addr}</div>
                  <div className="location-hours">{l.hours}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TOAST */}
      <div className={`toast${toast ? ' show' : ''}`}>✓ Message sent! We'll be in touch within 24 hours.</div>
    </div>
  );
}
